import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { YetiSocket } from '../yeti-socket';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IChat } from 'src/app/interface/chat';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Injectable({
	providedIn: 'root'
})
export class ChatUpdatedService {

	private echo: Echo<any>

	constructor() {
		this.echo = YetiSocket.connect();
	}

	public listener(type: string, id: number): Observable<IUpdated> {
		if (!type || !id) {
			return new Observable();
		}
		const subject = new Subject<IUpdated>();
		const channelEvent = environment.socketChannel;
		const listenEvent = StringHelper.sprintf('.chat_updated_%s_%d', type, id);
		this.echo
			.channel(channelEvent)
			.listen(listenEvent, (data: any) => subject.next(data));
		return subject.asObservable();
	}
}

interface IUpdated {
	chat?: IChat;
}
